import setupAmplitudeGuidesAndSurveys from 'bundles/page/lib/amplitudeGuidesAndSurveys';
import appStarterFactory from 'bundles/page/lib/appStarterFactory';
import appEnv from 'bundles/promo-template/appEnv';

setupAmplitudeGuidesAndSurveys();

export default appStarterFactory(appEnv);
